/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AsName1
 */
export interface AsName1 {
}

/**
 * Check if a given object implements the AsName1 interface.
 */
export function instanceOfAsName1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AsName1FromJSON(json: any): AsName1 {
    return AsName1FromJSONTyped(json, false);
}

export function AsName1FromJSONTyped(json: any, ignoreDiscriminator: boolean): AsName1 {
    return json;
}

export function AsName1ToJSON(value?: AsName1 | null): any {
    return value;
}

